import { roomTypes } from 'common/consts/room-types.consts';

export const getIsCollectionRoomType = (roomType: string | null) => {
  return !!roomType && [roomTypes.tile, roomTypes.wallpaper].includes(roomType)
}
